/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
import { taxPayment } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import createExtend from '@/components/createExtend';
import Add from '../add.vue';

//初始化
export let example = new TableRenderClass({ fields, search });

/*主页面入口*/
export const main = isYyjd => {
  const baseTable = example.createPart({
    name: '我收到的',
    showClearAll: true,
    search: ['gys', 'monthrange'],
    list: data => {
      return new Promise(async resolve => {
        const res = await taxPayment.list({
          ...data,
          proofType: 1
        });
        resolve(res);
      });
    },
    requestNow: true,
    fields: [
      'index',
      'gys',
      'wsqy',
      'qyNo',
      'month',
      'startDate',
      'endDate',
      'wsCount',
      'uploadDt',
      'operation'
    ]
  });
  return [
    {
      name: '完税证明',
      childMenu: isYyjd
        ? [
            example.createPart({
              name: '我发起的',
              search: ['kfqy', 'monthrange', 'status'],
              showClearAll: true,
              list: data => {
                return new Promise(async resolve => {
                  const res = await taxPayment.list({
                    ...data,
                    proofType: 2
                  });
                  resolve(res);
                });
              },
              moreBtnArr: [
                {
                  name: '新增完税证明',
                  type: 'warning',
                  async fn(app, table) {
                    table.$xrkDialog({
                      title: '新增完税证明',
                      width: '1000px',
                      showCancel: false,
                      showConfirm: false,
                      $slots: {
                        default: table.$createElement(Add, {
                          props: {},
                          on: {
                            confirm: () => {
                              table.saveSuccess();
                              table.$xrkDialog.remove();
                            }
                          }
                        })
                      }
                    });
                  }
                }
              ],
              requestNow: true,
              fields: [
                'index',
                'kfqy',
                'qyNo',
                'month',
                'startDate',
                'endDate',
                'wsCount',
                'newDt',
                'uploadUserPhone',
                'auditStatus',
                'operation1'
              ]
            }),
            baseTable
          ]
        : [baseTable]
    }
  ];
};
